import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  justify-content: center;
  // min-width: 188px;
  min-width: ${(props) => props.width || "188px"};
  max-width: 200px;
  height: 148px;
  padding: 32px 40px 32px 40px;
  margin: 10px;
  border: 1px solid #cac4d0;
  background-color: #ffffff;
  cursor: pointer;
  border: 2px solid ${(props) => (props.isSelected ? "#625B71" : "#cac4d0")};
  background-color: ${(props) => (props.isSelected ? "#F7F2FA" : "#ffffff")};
`;

export const SizeImage = styled.img`
  width: 77px;
  height: 48px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  margin-top: 6px;
`;

export const Title = styled.p`
  font-size: 16px;
  text-align: center;
  color: #21005d;
  font-family: DM Sans;
  margin-top: 10px;
  font-weight: 500;
`;
